module.exports = __webpack_public_path__ + "img/pic_nh.a212fcb7.png";